import styled from 'styled-components';
import { PropertyCardSaveAreaMixin } from '../../mixins/components/PropertyCardSaveAreaMixin';
export var StyledPropertyCardSaveArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardSaveArea",
  componentId: "c11n-8-111-1__sc-1ja600h-0"
})(["", ""], PropertyCardSaveAreaMixin);